import { Action, Link } from '@/types/general';

export enum InvoiceStatus {
  Open = 'open',
  Completed = 'completed',
  Rejected = 'rejected'
}

export enum InvoiceType {
  Bill = 'bill',
  Credit = 'credit',
  Advice = 'advice',
  Reminder = 'reminder'
}

export interface Invoice {
  type?: InvoiceType;
  rawType?: string;
  invoiceDate: string;
  amount: string;
  currency: string;
  dueDate?: string;
  overdue?: boolean;
  readFlag: string;
  status: InvoiceStatus;
  reopened: boolean;
  invoiceReference?: string;
  _links: {
    self: Link;
    biller: Link & { name: string; firstContact: string };
    'related-billers'?: Link;
    pdf: Link;
    'payment-options'?: Link;
  };
  _actions: {
    read?: Action;
    approve?: Action;
    reject?: Action;
    complete?: Action;
  };
}
